import { IRootState } from '..'

export const getNews = (state: IRootState, id: string) =>
  state.newsState.newsList.filter(news => news.id === id)[0]
